import {atomWithStorage} from "jotai/utils";

const LOCAL_STORAGE_IMPERSONATION_KEY = "impersonation";

/**
 * Current user impersonation id. Reads impersonation id from local storage upon initialization and syncs it
 * to local storage on set
 */
export const impersonationAtom = atomWithStorage<string | undefined>(LOCAL_STORAGE_IMPERSONATION_KEY, undefined);
